import { type ClassNameValue, twMerge } from "tailwind-merge";

export const twClassMerge = (...classLists: ClassNameValue[]) =>
  twMerge(classLists);
